import type { HRLeaveStatus } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  status: HRLeaveStatus
  className?: string
}

export function LeaveStatusBadge({ status, className }: Props) {
  const { t } = useTranslation('hr')
  const styles: Record<HRLeaveStatus, string> = {
    draft: 'bg-muted text-muted-foreground',
    pending_manager: 'bg-muted text-foreground',
    pending_hr: 'bg-muted text-foreground',
    approved: 'bg-primary text-primary-foreground',
    taken: 'bg-background text-foreground',
    rejected: 'bg-muted text-muted-foreground line-through',
    cancelled: 'bg-muted text-muted-foreground line-through',
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        styles[status],
        className,
      )}
    >
      {t(`leave_status.${status}`, { defaultValue: status })}
    </span>
  )
}
